import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../Context/auth";
import Spinner from "../Spinner";

export default function PrivateRoute() {
  const [ok, setOk] = useState(false);
  const [auth] = useAuth();

  useEffect(() => {
    const authCheck = async () => {
      try {
        const res = await axios.get(
          "https://bioopay-full-backend.onrender.com/api/v1/users/auth-user",
          {
            headers: {
              Authorization: `Bearer ${auth?.token}`,
              "Cache-Control": "no-cache",
            },
          }
        );
        if (res.data.ok) {
          setOk(true);
        } else {
          setOk(false);
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        setOk(false);
      }
    };
    if (auth?.token) authCheck();
  }, [auth?.token]);

  // Jab tak check ho raha ho, kuch bhi mat dikhao
  // In PrivateRoute.js
  if (!ok) return; // Show a loading state instead of `null`

  return ok ? <Outlet /> : <Spinner />;
}
